import React, { MouseEvent } from 'react';
import { Grid, Box, Typography, Collapse, useMediaQuery } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { TodoItem } from './DashboardTodoTypes';
import { styles, getCardStyle } from './DashboardTodoConstants';
import { TodoMenu, TodoContent } from './DashboardTodoMenu';
import { theme } from '../../../../theme/DashboardTheme';

export const TodoCard = ({
  item,
  isOpen,
  isCompleted,
  isPending,
  isNoActionNeeded,
  onOpen,
  anchorEl,
  menuWidth,
  onClose,
  onConfirm,
  onTriggerOptout,
  onLater,
  index,
  total,
}: {
  item: TodoItem;
  isOpen: boolean;
  isCompleted: boolean;
  isPending?: boolean;
  isNoActionNeeded?: boolean;
  onOpen: (event: MouseEvent<HTMLElement>, id: number) => void;
  anchorEl: HTMLElement | null;
  menuWidth?: number;
  onClose: () => void;
  onConfirm?: () => void;
  onTriggerOptout?: () => void;
  onLater?: () => void;
  index: number;
  total: number;
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid item xs={12} md={6} lg={12 / total} columnSpacing={3} sx={{ ...styles.card, ...getCardStyle(index, total), my: { xs: 1.5, md: 0 } }}>
      <Box onClick={(e) => onOpen(e, item.id)} sx={styles.headerBox}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isCompleted ? (
            <CheckCircleIcon sx={{ color: '#14A44D', mr: 1.5, fontSize: '20px' }} />
          ) : isPending ? (
            <ErrorIcon sx={{ color: '#E4A11B', mr: 1.5, fontSize: '20px' }} />
          ) : (
            <ErrorIcon sx={{ color: '#DC4C6A', mr: 1.5, fontSize: '20px' }} />
          )}
          <Typography sx={styles.accordionHeader}>{item.title}</Typography>
        </Box>

        <ExpandMoreIcon
          sx={{
            color: '#3A155A',
            transition: '0.2s',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            fontSize: { xs: '18px', sm: '24px' },
          }}
        />
      </Box>

      {isMobile ? (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <TodoContent
            item={item}
            isCompleted={isCompleted}
            isNoActionNeeded={isNoActionNeeded}
            onClose={onClose}
            onConfirm={onConfirm}
            onTriggerOptout={onTriggerOptout}
            onLater={onLater}
          />
        </Collapse>
      ) : (
        <TodoMenu
          item={item}
          anchorEl={anchorEl}
          isOpen={isOpen}
          isCompleted={isCompleted}
          isNoActionNeeded={isNoActionNeeded}
          menuWidth={menuWidth}
          onClose={onClose}
          onConfirm={onConfirm}
          onTriggerOptout={onTriggerOptout}
          onLater={onLater}
        />
      )}
    </Grid>
  );
};
